<div fxLayout="row" fxLayoutAlign="center center" class="mb-20">
  <div fxLayout="column" fxFlex="80%"
    fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
    <br />
    <br />
    <h1 name="faq-header" class="mat-h1"><b i18n="@@button-info-faq">FAQs</b></h1>
    <div fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="5%">
      <div fxLayout.xs="column" fxLayout.sm="column" fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="space-evenly start" fxLayoutGap.xs="20px" fxLayoutGap.sm="20px">
        <mat-card fxFlex="45%" class="mat-elevation-z4 faq-card">
          <mat-card-content fxLayout="column" fxLayoutGap="20px" class="faq-card-content">
              <h3><b i18n="@@faq">Frequently asked questions</b></h3>
              <h3><b i18n="@@general-question">General questions</b></h3>
              <p><i i18n="@@really-free">Q. Is this really free?</i><br>
                <span i18n="@@yes-free">A. Yes, all courses are completely free. You can take as many courses as you like, and get as much help as you need from your tutors, for no charge.</span>
              </p>
  
              <h3><b i18n="@@courses">Courses</b></h3>
              <p><i i18n="@@do-any-course">Q. Do any of the courses offered here lead to a qualification?</i><br>
                <span i18n="@@yes-course">A. Yes, all courses are written to support you to achieve an Essential Skills Wales qualification. Talk to your tutor for details.</span>
              </p>
              <p><i i18n="@@have-to-work">Q. Do I have to work with a tutor, or can I just work along on my own?</i><br>
                <span i18n="@@for-certain">A. For certain courses you will be assigned a tutor, but you don’t have to ask them for help if you don’t want to! Feel free to work along on your own. The tutor will always be there if you do need to ask someone for help.</span>
              </p>
            </mat-card-content>
        </mat-card>
        <mat-card fxFlex="45%" class="mat-elevation-z4 faq-card">
          <mat-card-content fxLayout="column" class="faq-card-content">
              <h3><b i18n="@@supported-browsers">Supported browsers</b></h3>
              <p i18n="@@connection-speed">Connection speed</p>
                <ul>
                  <li i18n="@@broadband-connection">Broadband connection recommended</li>
                </ul>
              <p i18n="@@os-minimum">OS / Browser (minimum)</p>
                <ul>
                  <li>Windows Vista SP2
                    <ul>
                      <li>Microsoft Edge - <span i18n="@@latest-version">latest version</span></li>
                      <li>Firefox – <span i18n="@@latest-version">latest version</span></li>
                      <li>Google Chrome – <span i18n="@@latest-version">latest version</span></li>
                      <li>Safari – <span i18n="@@latest-version">latest version</span></li>
                    </ul>
                  </li>
                  <li>Mac OS X v10.7 “Lion”
                    <ul>
                      <li>Safari 6.1.x</li>
                    </ul>
                  </li>
                  <li>Android 4.2
                    <ul>
                      <li>Google Chrome</li>
                    </ul>
                  </li>
                  <li>iOS 7
                    <ul>
                      <li>Safari</li>
                    </ul>
                  </li>
                </ul>
              <p i18n="@@screen-reso">Screen resolution</p>
                <ul>
                  <li i18n="@@higher-pc">1024 x 768 or higher on a laptop or PC</li>
                  <li i18n="@@min-width">Minimum width of 800px on a mobile device</li>
                </ul>
              <p i18n="@@other-requirement">Other requirements – note that some activities rely on ‘plugins’ in your web browser and these may not be available on all devices.</p>
                <ul>
                  <li i18n="@@js-enabled">JavaScript enabled</li>
                  <li i18n="@@pop-up-block">Pop-up blocking level – low</li>
                  <li i18n="@@soundcard">Soundcard, plus either speakers or headphones</li>
                </ul>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div *ngIf="isLoggedIn && (userProfile$ | async)?.roleId == learnerRole" class="browser-note" name="browser-note-container">
      <app-browser-note></app-browser-note>
    </div>
  </div>
</div>
